<template>
  <div class="flex min-h-[200px] flex-col overflow-hidden rounded-[20px]">
    <p class="text-[16px]/[1.2em]" v-text="label" />
    <p
      class="type-font-salt text-[64px]/[0.9em] font-medium tracking-[-0.03em] md:text-[80px] lg:text-[64px] xl:text-[80px]"
      :class="$slots.default ? 'mt-5' : 'mt-auto'"
      v-text="displayStat"
    />
    <div v-if="$slots.default" class="mt-auto pt-6">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string
  stat: string | number | null | undefined
}

const props = defineProps<Props>()

const numericStat = computed(() =>
  typeof props.stat === 'number' ? props.stat : null,
)

const reducedMotion = usePreferredReducedMotion()
const counting = shallowRef(false)
const count = shallowRef(0)
const animatedCount = useTransition(count, {
  duration: 1500,
  transition: [0.4, 0, 0.2, 1],
  onFinished: () => {
    counting.value = false
  },
})

onMounted(() => {
  if (numericStat.value === null || reducedMotion.value === 'reduce') return
  counting.value = true
  count.value = numericStat.value
})

watch(numericStat, (stat) => {
  if (stat !== null) count.value = stat
})

const displayStat = computed(() => {
  if (counting.value && numericStat.value !== null) {
    // Tick upward in steps of 100 until the transition lands on the real figure.
    return formatNumber(
      Math.min(numericStat.value, Math.floor(animatedCount.value / 100) * 100),
    )
  }
  return typeof props.stat === 'number'
    ? formatNumber(props.stat)
    : (props.stat ?? '—')
})
</script>
